module.exports = __webpack_public_path__ + "img/3화_11(1).0ba4f9d0.jpg";